import { useFetch } from "../../hooks/useFetch";

type MetricsData = {
	totalOrgs: number;
	activeOrgs: number;
	revenue: { amount: number; currency: string; status: string };
};

type WebhookHealthMetrics = {
	totalDeliveries: number;
	failedDeliveries: number;
	dlqPending: number;
	tenantsQueried: number;
	tenantsFailed: number;
};

export function AdminDashboardPage() {
	const { data, loading, error } = useFetch<MetricsData>("/api/admin/metrics");
	const {
		data: webhookData,
		loading: webhookLoading,
		error: webhookError,
	} = useFetch<WebhookHealthMetrics>("/api/admin/webhooks/metrics");

	return (
		<div>
			<h1 className="text-2xl font-bold text-gray-900 mb-4">Admin Dashboard</h1>

			{error && <p className="text-red-600 text-sm mb-3">{error}</p>}

			{loading && !data && <p className="text-gray-500 text-sm">Loading…</p>}

			{data && (
				<div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
					<div className="border rounded p-4">
						<p className="text-sm text-gray-500">Total Workspaces</p>
						<p className="text-3xl font-bold text-gray-900 mt-1">
							{data.totalOrgs}
						</p>
					</div>
					<div className="border rounded p-4">
						<p className="text-sm text-gray-500">Active Workspaces</p>
						<p className="text-3xl font-bold text-gray-900 mt-1">
							{data.activeOrgs}
						</p>
					</div>
					<div className="border rounded p-4">
						<p className="text-sm text-gray-500">Revenue</p>
						<p className="text-3xl font-bold text-gray-900 mt-1">
							${data.revenue.amount}
						</p>
						<p className="text-xs text-gray-400 mt-1">{data.revenue.status}</p>
					</div>
				</div>
			)}

			<h2 className="text-lg font-semibold text-gray-900 mt-8 mb-3">
				Webhook Health
			</h2>

			{webhookError && (
				<p className="text-red-600 text-sm mb-3">{webhookError}</p>
			)}

			{webhookLoading && !webhookData && (
				<p className="text-gray-500 text-sm">Loading…</p>
			)}

			{webhookData && (
				<div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
					<div className="border rounded p-4">
						<p className="text-sm text-gray-500">Total Deliveries</p>
						<p className="text-3xl font-bold text-gray-900 mt-1">
							{webhookData.totalDeliveries}
						</p>
					</div>
					<div className="border rounded p-4">
						<p className="text-sm text-gray-500">Failed Deliveries</p>
						<p
							className={`text-3xl font-bold mt-1 ${webhookData.failedDeliveries > 0 ? "text-red-600" : "text-gray-900"}`}
						>
							{webhookData.failedDeliveries}
						</p>
					</div>
					<div className="border rounded p-4">
						<p className="text-sm text-gray-500">DLQ Pending</p>
						<p
							className={`text-3xl font-bold mt-1 ${webhookData.dlqPending > 0 ? "text-red-600" : "text-gray-900"}`}
						>
							{webhookData.dlqPending}
						</p>
					</div>
				</div>
			)}
		</div>
	);
}
